var map = {
	"./slide11-piece-11.png": "7fe9",
	"./slide11-piece-12.png": "4d89",
	"./slide11-piece-13.png": "6cb5",
	"./slide11-piece-14.png": "278d",
	"./slide11-piece-15.png": "6329",
	"./slide11-piece-16.png": "678d",
	"./slide11-piece-21.png": "a35d",
	"./slide11-piece-22.png": "bbc4",
	"./slide11-piece-23.png": "5285",
	"./slide11-piece-24.png": "f52f",
	"./slide11-piece-25.png": "2692",
	"./slide11-piece-26.png": "8049",
	"./slide11-piece-31.png": "bffe",
	"./slide11-piece-32.png": "ef91",
	"./slide11-piece-33.png": "a6fe",
	"./slide11-piece-34.png": "5d75",
	"./slide11-piece-35.png": "a62d",
	"./slide11-piece-36.png": "8acb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b076";